import React from "react";
import { useDrag } from "react-dnd";

const DraggableCoin = ({ coin, onClick }) => {
  const [{ isDragging }, drag] = useDrag(() => ({
    type: "MONEY",
    item: { value: coin.value },
    collect: (monitor) => ({
      isDragging: !!monitor.isDragging(),
    }),
  }));

  return (
    <div
      style={{
        cursor: "default", // or "pointer" if you want hover cursor on div
        display: "inline-block",
        marginBottom: "8px",
        textAlign: "center",
      }}
    >
      <img
        ref={drag} // <-- attach drag ref here
        onClick={() => onClick(coin.value)}
        src={coin.image}
        alt={`${coin.name}`}
        style={{
          cursor: "grab",
          width: "80px",
          height: "80px",
          objectFit: "contain",
          opacity: isDragging ? 0.5 : 1,
          borderRadius: "50%",
          userSelect: "none",
        }}
      />
      <div style={{ fontWeight: "bold", fontSize: "1rem" }}>{coin.name}</div>
    </div>
  );
};

export default DraggableCoin;
